import { useEffect, useState } from "react";
import CSDTable from "@cloudscape-design/components-themed/table";
import {
  Box,
  Header,
  Link,
  Pagination,
} from "@cloudscape-design/components-themed";
import { useGetConsentInformationTransferResultsQuery, useLazyGetConsentInformationTransferResultFileDownloadQuery } from "../../features/api";
import { COMMON_LABELS } from "../default-constants";
import { LABELS, LIST_PAGE_SIZE } from "./constants";
import { useCollection } from "@cloudscape-design/collection-hooks";
import { formatDateTime } from "../../utils/format";

/* 
承諾移管情報転送結果一覧
 */
const Table = () => {
  // 承諾情報移管結果一覧API呼び出し
  const { data, isFetching } = useGetConsentInformationTransferResultsQuery();

  // 一覧ページ数
  const [currentPageIndex, setCurrentPageIndex] = useState(1);
  // 表示用リストに格納
  const listData = data || [];

  const { items, actions, paginationProps } = useCollection(listData, {
    pagination: { pageSize: LIST_PAGE_SIZE },
  });

  useEffect(() => {
    // 一覧変更ごとにページ切り替え
    setCurrentPageIndex(1);
  }, [data]);

  // ファイルダウンロードAPIフック
  const [downloadFile] =
    useLazyGetConsentInformationTransferResultFileDownloadQuery();

  // ファイルダウンロード処理
  const onFileDownload = async (fileId: number) => {
    // 実際のダウンロードAPI呼び出し
    await downloadFile(fileId).unwrap();
  };

  const columnDefinitions = [
    {
      id: "fileType",
      header: LABELS.FILE_TYPE,
      cell: (e: any) => e.fileType || COMMON_LABELS.HYPHEN,
    },
    {
      id: "fileName",
      header: LABELS.FILE_NAME,
      cell: (e: any) =>
        e.fileName ? (
          <Link onFollow={() => onFileDownload(e.fileId)} href="#">
            {e.fileName}
          </Link>
        ) : (
          COMMON_LABELS.HYPHEN
        ),
    },
    {
      id: "applicationDate",
      header: LABELS.APPLICATION_DATE,
      cell: (e: any) => {
        const date = e.applicationDate;
        return (date && date !== "") ? formatDateTime(date) : COMMON_LABELS.HYPHEN;
      },
    },
    {
      id: "fileCreatedAt",
      header: LABELS.FILE_CREATED_AT,
      cell: (e: any) => {
        const date = e.fileCreatedAt;
        return (date && date !== "") ? formatDateTime(date) : COMMON_LABELS.HYPHEN;
      },
    },
    {
      id: "applicationMail",
      header: LABELS.APPLICATION_EMAIL,
      cell: (e: any) => {
        if (Array.isArray(e.applicationMail)) {
          return e.applicationMail.map((email: string, index: number) => (
            <span key={index}>
              {email}
              {index < e.applicationMail.length - 1 && <br />}
            </span>
          ));
        }
        return e.applicationMail;
      },
    },
  ];

  return (
    <CSDTable
      columnDefinitions={columnDefinitions}
      loading={isFetching}
      loadingText={COMMON_LABELS.CSD.LOADING_TEXT}
      items={items}
      resizableColumns
      stickyHeader
      header={<Header>{LABELS.RESULT_FILE}</Header>}
      pagination={
        <Pagination
          {...paginationProps}
          currentPageIndex={currentPageIndex}
          onChange={(event) => {
            actions.setCurrentPage(event.detail.currentPageIndex);
            setCurrentPageIndex(event.detail.currentPageIndex);
          }}
        />
      }
      empty={
        <Box textAlign="center" color="inherit">
          {COMMON_LABELS.CSD.NO_DATA}
        </Box>
      }
    />
  );
};

export default Table;